import type { Dispatch } from 'react';

export const LANGUAGE_SET = 'LANGUAGE_SET';

export function setLanguage(code: string) {
    return (
        dispatch: Dispatch<{
            code: string;
            type: typeof LANGUAGE_SET;
        }>
    ) => {
        return dispatch({ code: code, type: LANGUAGE_SET });
    };
}
